import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { CssBaseline, Theme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';

import App from './App';
import AppStateProvider, { useAppState } from './state';
import { BrowserRouter as Router, Redirect, Route, Switch, useParams } from 'react-router-dom';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import LoginPage from './components/LoginPage/LoginPage';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import './types';
import { ChatProvider } from './components/ChatProvider';
import { ParticipantProvider } from './components/ParticipantProvider';
import { VideoProvider } from './components/VideoProvider';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';
import 'moment/locale/fr';
import ApendayStateProvider, { useApendayState } from './hooks/useApendayState/useApendayState';

const VideoApp = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  //const [scheduledMeeting, setScheduledMeeting] = useState<ScheduledMeeting>();
  //const [meeting, setMeeting] = useState<Meeting>();
  const [areaStyles, setAreaStyles] = useState();

  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const { URLUserName } = useParams<{ URLUserName?: string }>();

  const [roomName, setRoomName] = useState<string>('');

  const { meeting, scheduledMeeting, isAdmin } = useApendayState();

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <ParticipantProvider>
        <ChatProvider>
          <App meeting={meeting} scheduledMeeting={scheduledMeeting} />
        </ChatProvider>
      </ParticipantProvider>
    </VideoProvider>
  );
};

export const ReactApp = () => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <UnsupportedBrowserWarning>
      <Router>
        <AppStateProvider>
          l
          <Switch>
            <PrivateRoute exact path="/">
              <VideoApp />
            </PrivateRoute>
            <PrivateRoute path="/room/:URLRoomName/:URLUserName?">
              <ApendayStateProvider>
                <VideoApp />
              </ApendayStateProvider>
            </PrivateRoute>
            <Route path="/login">
              <LoginPage />
            </Route>
            <Redirect to="/" />
          </Switch>
        </AppStateProvider>
      </Router>
    </UnsupportedBrowserWarning>
  </MuiThemeProvider>
);

ReactDOM.render(<ReactApp />, document.getElementById('root'));
